import { useFormikContext } from 'formik'
import Styles from './Images.module.scss'
import { ImagesFieldProps } from 'components/Wizards/SelectImages/Types'
import { ImageCheckbox } from 'components/Wizards/SelectImages/ImageCheckbox'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { InnerCarousel } from 'components/Carousel/Carousel'
import { useImages, useUnsplashImages } from 'components/Wizards/SelectImages/ImagesProvider'
import { ImageSkeleton } from './ImageSkeleton'
import { ErrorImage } from 'components/Wizards/SelectImages/ErrorImage'
import { DeclarativeToast } from 'common/ToastMessage/DeclarativeToast'
import { ToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useIsMutating } from 'hooks/useIsMutating'
import { Image } from 'components/Wizards/SelectImages/Image'

export const ImagesField = ({ type = 'blog_post', embla }: ImagesFieldProps) => {
  const { values } = useFormikContext()
  const { photos, maxPhotos, isLoading, isError, retry, page } = useUnsplashImages()
  const { images } = useImages()
  const generatingImages = useIsMutating({ mutationKey: 'generateImage' })

  const length = isLoading ? maxPhotos * (page - 1) : maxPhotos * page
  const photosList = Array.from({ length }).map((_, index) => {
    if (isError) {
      return <ErrorImage onTryAgain={() => retry(values)} key={`error-${index}`} />
    }

    const photo = photos[index]

    return (
      <ImageCheckbox
        key={photo?.id}
        url={photo?.urls.small}
        value={photo?.urls.full}
        alt={photo?.alt_description || photo?.description || ''}
      />
    )
  })

  const imagesList = (images || []).map((image, index) => (
    <ImageCheckbox url={image} alt={image} key={`image-${index}`} />
  ))

  const loadingList = Array.from({ length: maxPhotos }).map((_, index) => (
    <Image key={index}>
      <ImageSkeleton />
    </Image>
  ))

  return (
    <>
      {!!generatingImages && (
        <DeclarativeToast>
          <ToastMessage toastMessage="Generating images..." variant="generating" />
        </DeclarativeToast>
      )}
      <fieldset className={Styles.fieldset}>
        <legend className={Styles.legend}>
          {type === 'blog_post'
            ? 'Pick up to 3 image suggestions to add to the post'
            : 'Pick one or more of the image suggestions to add to the post'}
        </legend>
        <ResponsiveDesign.Desktop>
          <div className={Styles.images}>
            {photosList}
            {imagesList}
            {isLoading && loadingList}
          </div>
        </ResponsiveDesign.Desktop>
        <ResponsiveDesign.Mobile>
          <InnerCarousel embla={embla}>
            {photosList}
            {imagesList}
            {isLoading && loadingList}
          </InnerCarousel>
        </ResponsiveDesign.Mobile>
      </fieldset>
    </>
  )
}
